import { ReactComponent as DeleteIcon } from '../../../assets/Icons/adornments/Trash.svg';
import { ReactComponent as OpenIcon } from '../../../assets/Icons/adornments/Open-New-Tab.svg';
import { ReactComponent as CSVIcon } from '../../../assets/Icons/files/CSV File.svg';
import { ReactComponent as XLSXIcon } from '../../../assets/Icons/files/XLSX File.svg';
import { ReactComponent as SDFIcon } from '../../../assets/Icons/files/SDF File.svg';
import { ReactComponent as GenericFileIcon } from '../../../assets/Icons/files/UploadedFile.svg';
import { ReactComponent as GenericDatasetIcon } from '../../../assets/Icons/files/UploadedDS.svg';
import { ReactComponent as GenericModelIcon } from '../../../assets/Icons/files/UploadedModel.svg';
import { ReactComponent as GenericPredictionIcon } from '../../../assets/Icons/navigation/Prediction.svg';
import { ReactComponent as GenericReadacrossIcon } from '../../../assets/Icons/navigation/Read-Across.svg';
import { MouseEvent } from 'react';
import { MIMEFileTypes } from './DragAndDropRawFile';

export default function SelectedItem({
    type,
    fileExt,
    name,
    metadata,
    deleteFn,
    hash,
    methods,
} : {
    type: 'file' | 'dataset' | 'model' | 'resultset' | 'readacross',
    fileExt?: MIMEFileTypes,
    name: string,
    metadata?: string,
    deleteFn?: (e: MouseEvent<HTMLButtonElement>) => void,
    hash?: string,
    methods?: string[],
}) {


    const renderIcon = () => {
        let icon = <></>;
        if (type === 'file') {
            if (fileExt === 'csv') {
                icon = <CSVIcon/>;
            } else if (fileExt === 'xlsx') {
                icon = <XLSXIcon/>;
            } else if (fileExt === 'sdf') {
                icon = <SDFIcon/>;
            } else {
                icon = <GenericFileIcon/>;
            }
        } else if (type === 'dataset') {
            icon = <GenericDatasetIcon/>;
        } else if (type === 'model') {
            icon = <GenericModelIcon/>;
        } else if (type === 'resultset') {
            icon = <GenericPredictionIcon />;
        } else {
            icon = <GenericReadacrossIcon />;
        }

        return icon;
    }

    const navigateFunc = () => {
        if (hash !== undefined) {
            let link = '';
            if (type === 'file') {
                link = `${process.env.PUBLIC_URL}/files/${hash}`;
            } else if (type === 'dataset') {
                link = `${process.env.PUBLIC_URL}/datasets/${hash}`;
            } else if (type === 'model') {
                link = `${process.env.PUBLIC_URL}/models/${hash}`;
            } else if (type === 'resultset') {
                link = `${process.env.PUBLIC_URL}/resultsets/${hash}`;
            } else {
                link = link = `${process.env.PUBLIC_URL}/readacross/${hash}`;
            }
            return link;
        } else {
            return '';
        }
    }

    return (
            <div className='w-full flex flex-col gap-4 justify-start items-stretch border border-outline rounded-lg p-4'>
                <div className='w-full flex justify-between items-stretch gap-4'>
                    <div className='flex justify-start items-start gap-4'>
                        <div className='rounded-lg p-2 bg-secondary'>
                            <div className='w-[24px] h-[24px] text-primary'>{renderIcon()}</div>      
                        </div>
                        <div className='flex flex-col justify-center items-start'>
                            <p className={`text-[14px] text-default font-medium break-all`}>{name}</p>
                            {metadata && <p className='text-[12px] text-disable'>{metadata}</p>}
                        </div>
                    </div>
                    <div className='flex justify-end items-start gap-2'>
                        {hash !== undefined && (
                            <a 
                                href={navigateFunc()} 
                                target='_blank' 
                                rel='noreferrer' 
                                className='w-[16px] h-[16px] text-disable hover:text-primary transition-all'
                            >
                                <OpenIcon/>
                            </a>
                        )}
                        {deleteFn !== undefined && (
                            <button 
                                onClick={deleteFn} 
                                className='w-[16px] h-[16px] text-disable hover:text-primary transition-all'
                            >
                                <DeleteIcon/>
                            </button>
                        )}
                    </div>
                </div>
                {methods !== undefined && (
                    <div className='w-full flex flex-col gap-2 justify-start items-start'>
                        <label className='text-[12px] font-medium'>Methods</label>
                        <div className='w-full flex justify-start items-center gap-3'>
                            {methods.map(method => (
                                <div className='bg-outline/[0.5] py-1 px-3 text-default text-[12px] rounded-md font-medium'>
                                    {method}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
    )
}